import React from "react";
import { Button, Col, Row } from "reactstrap";
import MDAFilter from "../../Payments/MDAFilter";
// import PositionTypeFilter from "./PositionTypeFilter";
// import Flatpickr from "react-flatpickr";
import OffCanvasFilter from "./OffCanvasFilter";
import { getYearDateRange } from "common/lib/dateUtils";
import RegionFilter from "pages/Payments/RegionFilter";

const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 5 }, (_, index) => {
    const year = currentYear - index;
    return { value: year.toString(), label: year.toString() };
  });
};

const Filters = ({
  setSearchValue,
  setPage,
  searchValue,
  setFilterValue,
  filterValue,
  defaultFilterValue,
  setSorted,
}: any) => {
  const [advancedFilter, setAdvancedFilter] = React.useState(false);

  const clearFilters = () => {
    setFilterValue(defaultFilterValue);
    setSearchValue("");
    setPage(1);
    setSorted([{ id: "createdAt", desc: true }]);
  };

  const yearOptions = React.useMemo(() => generateYearOptions(), []);

  return (
    <>
      <Row className="g-3 py-2">
        <Col xxl={3} lg={6}>
          {/* <h6 className="text-uppercase fs-12 mb-2">Search</h6> */}
          <div className="search-box">
            <input
              type="text"
              className="form-control"
              placeholder="Search payments..."
              onChange={(e) => {
                setSearchValue(e.target.value);
                setPage(1);
              }}
              value={searchValue}
            />
            <i className="ri-search-line search-icon"></i>
          </div>
        </Col>

        {/* <Col xxl={2} lg={6}>
          <select
            className="form-control"
            data-choices
            data-choices-search-false
            name="choices-single-default2"
            id="choices-single-default2"
            onChange={(e: any) => {
              setFilterValue({
                ...filterValue,
                status: e.target.value,
              });
              setPage(1);
            }}
            value={filterValue.status}
          >
            <option value="">Select Status</option>
            <option value="all">All</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </Col> */}

        <Col xxl={2} lg={6}>
          <select
            className="form-control"
            data-choices
            data-choices-search-false
            name="choices-single-default2"
            id="choices-single-default2"
            onChange={(e) => {
              const { firstDay, lastDay } = getYearDateRange(
                Number(e.target.value)
              );
              setFilterValue({
                ...filterValue,
                year: e.target.value,
                dateRange: {
                  fromDate: new Date(firstDay),
                  toDate: new Date(lastDay),
                },
              });
              setPage(1);
            }}
            value={filterValue.year}
          >
            <option value="">Select Year</option>
            {yearOptions.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </Col>

        <Col xxl={2} lg={6}>
          <RegionFilter
            onChange={(value: any) => {
              setFilterValue({ ...filterValue, region: value });
              setPage(1);
            }}
            value={filterValue.region}
          />
        </Col>

        <Col xxl={3} lg={6}>
          {/* <h6 className="text-uppercase fs-12 mb-2">Date Range</h6> */}
          {/* @ts-ignore */}
          <MDAFilter
            onChange={(value: any) => {
              setFilterValue({ ...filterValue, mda: value });
              setPage(1);
            }}
            value={filterValue.mda}
            regionId={filterValue.region?.value || ""}
          />
        </Col>
        <Col xxl={2} lg={4}>
          {/* <h6 className="text-uppercase fs-12 mb-xxl-4"> {` `}</h6> */}

          <div className="w-100 d-flex gap-2">
            <button
              className="flex-grow-1 btn btn-light"
              onClick={() => {
                clearFilters();
              }}
            >
              <i className="ri-restart-line align-bottom me-1"></i>
              Reset{" "}
            </button>

            <Button
              color="primary"
              className="flex-grow-1"
              onClick={() => {
                setAdvancedFilter(true);
              }}
            >
              <i className="ri-equalizer-line align-bottom me-1"></i>
              Filters
            </Button>
          </div>
        </Col>
      </Row>

      <OffCanvasFilter
        show={advancedFilter}
        onCloseClick={() => setAdvancedFilter(false)}
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        setPage={setPage}
        clearFilters={clearFilters}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
      />
    </>
  );
};

export default Filters;
